import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Color, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React, { useEffect } from 'react';

import { OperationType } from '../../../../../../../../../components/OperationType';
import { ResponsiveSuccessIconButton } from '../../../../../../../../../components/ResponsiveSuccessIconButton';
import { TableContentItemText } from '../../../../../../../../../components/TableContent';
import { useFixedIncomeSellAssetController } from '../../../../../hooks/products/FixedIncomeSell';
import { LateralBar } from '../../../components/LateralBar';

import { FixedIncomeItemSelectedTypes } from '.';

export const FixedIncomeItemSelectedTablet: React.FC<FixedIncomeItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
}) => {
  const id = offer.productIdNormalized;
  const {
    amountItem,
    handleChangeAmountItem,
    errorMessage,
    hasError,
    netFinancialValue,
    netFinancialValueFormatted,
  } = useFixedIncomeSellAssetController(offer);

  useEffect(() => {
    if (offer.orderQuantity === amountItem || !amountItem) {
      return;
    }
    const updatedOffer = {
      ...offer,
      orderQuantity: amountItem || 0,
      orderValue: netFinancialValue,
    };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amountItem]);

  return (
    <Box p="inline.xxs">
      <LateralBar
        backgroundColor={Color['product.rf']}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack flex={1} space="inline.xxxs">
        <HStack flex={1} justifyContent="space-between">
          <UI.ListItem testId="selected-product-name" title="Produto" stackProps={{ w: '1/3' }}>
            <TableContentItemText noOfLines={2} tooltip={offer.issuerFullName}>
              {offer.issuerFullName}
            </TableContentItemText>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-type" title="Tipo" stackProps={{ w: '1/3' }}>
            <OperationType title="Resgate" />
          </UI.ListItem>
          <UI.ListItem
            testId="selected-product-available-quantity"
            title="Qtd. disponível"
            stackProps={{ w: '1/3' }}>
            <TableContentItemText>{offer.availableQuantityNormalized}</TableContentItemText>
          </UI.ListItem>
        </HStack>
        <HStack flex={1} justifyContent="space-between">
          <UI.ListItem testId="selected-product-ir" title="IR" stackProps={{ w: '1/3' }}>
            <TableContentItemText>{offer.irFormatted}</TableContentItemText>
          </UI.ListItem>
          <UI.ListItem
            testId="selected-product-net-value"
            title="Valor líquido"
            stackProps={{ w: '1/3' }}>
            <TableContentItemText>{netFinancialValueFormatted}</TableContentItemText>
          </UI.ListItem>
          <UI.ListItem
            testId="selected-product-availableInAccount"
            title="Disponível em conta"
            stackProps={{ w: '1/3' }}>
            <TableContentItemText>{offer.availableInAccountNormalized}</TableContentItemText>
          </UI.ListItem>
        </HStack>
        <HStack flex={1} flexGrow={1} space="inline.xxxs" alignItems="flex-end">
          <UI.ListItem
            testId="selected-product-name"
            title="Valor aplicado"
            stackProps={{ flexGrow: 1 }}>
            <Stack flexGrow={1} w="full">
              <UI.InputStepper
                stepperValue={1}
                max={offer.availableAmount}
                min={1}
                name={`fixed-income-amount-order-input-${id}`}
                keyboardType="numeric"
                fontSize={Typography['fontsize.md']}
                defaultValue={amountItem || 0}
                onChange={handleChangeAmountItem}
                showErrorMessage={false}
                {...(hasError && {
                  customError: errorMessage,
                  showErrorMessage: true,
                })}
              />
            </Stack>
          </UI.ListItem>
          <ResponsiveSuccessIconButton />
        </HStack>
      </VStack>
    </Box>
  );
};
